import { render, staticRenderFns } from "./discMain.vue?vue&type=template&id=14cccae1&scoped=true"
import script from "./discMain.vue?vue&type=script&lang=js"
export * from "./discMain.vue?vue&type=script&lang=js"
import style0 from "./discMain.vue?vue&type=style&index=0&id=14cccae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cccae1",
  null
  
)

export default component.exports